<template>

  <section v-if="sliderHome.length" class="home-slider-container">

    <div class="home-slider-wrapper" :class="'slide-pos-' + currentIndex">

      <div v-for="(slide, index) in sliderHome" :key="index" class="slider-item-avance">

        <img :src="$imgURL + slide.insInstitucionalImagens[0].itgUrlImagem" class="slider-bg-image"
          alt="Background Slider" />

        <div class="overlay"></div>

        <div class="container slider-content-fixed">
          <div class="row no-gutters slider-text align-items-center justify-content-center">
            <div class="col-md-7">

              <h1 class="mb-4 text-center">{{ slide.itiNome }}</h1>
              <span class="subheading text-center">{{ slide.itiReferencia }}</span>

              <p v-if="slide.itiTextoBtn1" class="text-center">
                <router-link :to="slide.itiLinkBtn1" class="lider-btn px-4 py-3 mt-3">
                  {{ slide.itiTextoBtn1 }}
                </router-link>
              </p>
            </div>
          </div>
        </div>
      </div>

    </div>

    <button class="slider-nav prev hidden-sm hidden-xs" @click="prevSlide">‹</button>
    <button class="slider-nav next hidden-sm hidden-xs" @click="nextSlide">›</button>
  </section>

</template>

<script>
import axios from "axios";

export default {
  name: "PageSlider",

  data() {
    return {
      sliderHome: [],
      slide: [],
      currentIndex: 0,
      autoplayInterval: null,
    };
  },

  async mounted() {
    await this.fetchSlides();

    // inicia autoplay só depois que o slider carregar
    if (this.sliderHome.length > 0) {
      this.startAutoplay();
    }
  },

  beforeUnmount() {
    clearInterval(this.autoplayInterval);
  },

  methods: {

    startAutoplay() {
      clearInterval(this.autoplayInterval);

      this.autoplayInterval = setInterval(() => {
        this.nextSlide();
      }, 5000);
    },

    nextSlide() {
      this.currentIndex =
        (this.currentIndex + 1) % this.sliderHome.length;
      this.startAutoplay();
    },

    prevSlide() {
      this.currentIndex =
        (this.currentIndex - 1 + this.sliderHome.length) %
        this.sliderHome.length;
      this.startAutoplay();
    },

    async fetchSlides() {
      try {
        const response = await axios.get(
          '/Process/InsInstitucional/institucional/34/slides/0/x'
        );

        this.sliderHome = response.data.sort(
          (a, b) => (parseInt(a.itiOrdem) || 0) - (parseInt(b.itiOrdem) || 0)
        );
        //console.log('sliderHome')
        //console.log(this.sliderHome)
      } catch (error) {
        console.error("Erro ao carregar sliders:", error);
      }
    }

  },

};
</script>

<style scoped>
/* Container e Trilho */
.home-slider-container {
  position: relative;
  width: 100%;
  height: 600px;
  overflow: hidden;
}

.home-slider-wrapper {
  display: flex;
  width: 1000%;
  /* Espaço para vários slides de 100% cada */
  transition: all 0.6s ease-in-out;
}

/* Classes de Posicionamento (Substitui o style inline) */
.slide-pos-0 {
  transform: translateX(0%);
}

.slide-pos-1 {
  transform: translateX(-10%);
}

.slide-pos-2 {
  transform: translateX(-20%);
}

.slide-pos-3 {
  transform: translateX(-30%);
}

/* ... adicione mais se necessário ... */

/* Item do Slider */
.slider-item-avance {
  width: 10%;
  /* Cada slide ocupa 1/10 do wrapper de 1000% */
  height: 600px;
  position: relative;
  display: flex;
  align-items: center;
}

/* Simulação de Background Image */
.slider-bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* Faz a imagem se comportar como background-size: cover */
  z-index: 1;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 2;
}

.slider-content-fixed {
  position: relative;
  z-index: 3;
  /* Garante que o texto fique acima da imagem e do overlay */
}

/* Texto e Botões */
.subheading {
  color: #fff;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  display: block;
}

h1.mb-4 {
  color: #fff;
  font-weight: 800;
  font-size: 3.5rem;
}

.slider-nav {
  position: absolute;
  top: 50%;
  z-index: 10;
  background: none;
  border: none;
  color: white;
  font-size: 50px;
  cursor: pointer;
}

.prev {
  left: 20px;
}

.next {
  right: 20px;
}

/* Responsivo Mobile */
@media (max-width: 768px) {

  .home-slider-container,
  .slider-item-avance {
    height: 400px;
    margin-top: 30px;
  }

  h1.mb-4 {
    font-size: 2rem;
  }
}
</style>
